// extracted by mini-css-extract-plugin
module.exports = {"slider":"gAk11","slider-item":"_2S6cH","sliderItem":"_2S6cH","empty-state":"MK0WX","emptyState":"MK0WX"};